export const DYN_WC_FILENAME = 'index-BOlruIU3';
